import firebase, { database } from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import endOfMonth from "date-fns/end_of_month";
import addDays from 'date-fns/add_days';
import startOfWeek from 'date-fns/start_of_week'
import subMonths from 'date-fns/sub_months';;
import parse from 'date-fns/parse'
import addMonths from 'date-fns/add_months';
import addYears from 'date-fns/add_years';
import { map } from 'highcharts';
import { isWeekend } from 'date-fns';
import question from './question';
import { getTeamByCompany } from './core/cacheService';
//import axios from 'axios'
//const apiUrl = 'http://54.179.6.33:3000'
//const apiUrl = 'http://localhost:3000'
export default {
  namespaced: true,
  state: {
    user: '',
    team: '',
    engagement: {
      engagementKey: [],
      engagementType:'',
      challenges: {
        dailyCheck: "",
        peerFeedback: "",
        feedback: "",
        happilyVillage: "",
        superFeedback: "",
        rewards: "",
        recognition: "",
        favoritedSparks: "",
        superRecognition: "",
        NetworkBuilding: "",
      },
    },
    directReports: {
      engagedFocus: 0,
      engagedFocusType: "superEngaged",
      engagedValue: {
        superEngaged: 0,
        oldSuperEngaged: 0,
        highlyEngaged: 0,
        oldHighlyEngaged: 0,
        moderatelyEngaged: 0,
        oldModeratelyEngaged: 0,
        somewhatEngaged: 0,
        oldSomewhatEngaged: 0,
        notEngaged: 0,
        oldNotEngaged: 0,
      },
      engagedData: [],
    },
    directReportsLoading: true,
    directReportsEngagedValue: {
      superEngaged: 0,
      oldSuperEngaged: 0,
      highlyEngaged: 0,
      oldHighlyEngaged: 0,
      moderatelyEngaged: 0,
      oldModeratelyEngaged: 0,
      somewhatEngaged: 0,
      oldSomewhatEngaged: 0,
      notEngaged: 0,
      oldNotEngaged: 0,
    },
    directReportsEngagedData: [],
    directReports1: {},
    dailyContributions:'',
    youFeeling:[],
    teamFeeling:[],
    feeling:{good: 0,okay: 0,critical: 0},
    loading: true,
    userDetail:{},
    performingData:[],
    userCardData:{},
    directReportsCardData:[],
    growingData: {},
    loadingStatus: false,
    talentTeam:{},
    loadingProgress:0
    
  },
  mutations: {
    setTeam(state: any, result: any) {
      state.team = result
    },
    setEngagement(state: any, result: any) {
      state.engagement = result
    },
    setdirectReports(state: any, result: any) {
      state.directReports = result
    },
    setloading(state: any, result: any) {
      state.loading = result
    },
    setFeeling(state:any, result:any) {
      state.feeling = result
    },
    setPartTalentTeam(state:any, result:any) {
           
      state.directReportsCardData = result
  },
    setDirectReportsEngagedValue(state: any, result: any) {
      state.directReportsEngagedValue = result
    },
    setDirectReportsEngagedData(state: any, result: any) {
      state.directReportsEngagedData = result
    },
    setDirectReportsLoading(state: any, result: any) {
      state.directReportsLoading = result
    },
    setuserDetail(state: any, result: any) {
        state.userDetail = result
      },
    setContributions(state:any, result:any) {
        state.dailyContributions = result
    },
    setYouFeeling(state:any, result:any) {
      state.youFeeling = result
  },
  setTeamFeeling(state:any, result:any) {
    state.teamFeeling = result
  },
  setPerformingData(state:any, result:any) {
    state.performingData = result
  },
  setuserCardData(state: any, value: any) {
    state.userCardData = value
  },
  setGrowingData(state:any, result:any) {
    state.growingData = result
},
setTalentTeam(state:any, result:any) {
  state.talentTeam = result
},
setloadingStatus(state: any, value: any) {
  state.loadingStatus = value
},
setLoadingProgress(state: any, value: any) {
  state.loadingProgress = value
},

  },
  actions: {

    async getTeam({ commit, dispatch, rootState, state ,getters}: any, value: any) {
 
      commit("setLoadingProgress",state.loadingProgress+10)
      const allUserKey =rootState.main.allUser
    //   await firebase.database().ref('users').orderByChild("company").equalTo(value.company).once('value', (snapshot) => {
    //     snapshot.forEach((childSnapshot) => {
    //         let _data = childSnapshot.val();
    //         const emailKey = _data.email.replace(/\./g, '||')
    //         if(rootState.monthlyInsignhts.teamAll[_data.team]){
    //                 allUserKey[emailKey]=_data
    //         }
    //     })

    // })
      commit('setTeam', allUserKey)
      dispatch('getuserDetail',value)
      dispatch('getReportMonthly',value)
      
      
      
    },
    getuserDetail({ commit, dispatch, rootState, state }: any, value: any){
            
      let pastMonth = value.num_month - 1;
      let year = parseInt(format(value.year, "YYYY"));
      let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
      var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
      var talentTeam={}
      var axios = require('axios');
      var FormData = require('form-data');
      var data = new FormData();
      data.append('date', value.year+'-'+value.num_month+'-'+lastDayOfMonth);
      data.append('company', value.company);
      data.append('email', value.email);
      
      var config = {
        method: 'post',
        url: 'https://api2.happily.ai/api/gettalentandnetwork',
        headers: {
          'Accept': 'text/html',
        },
        // headers: { 
        //   ...data.getHeaders()
        // },
        data : data
      };
      
      axios(config)
      .then(function (response) {
        const data = response.data
                let userDetail={
                  totalConnections: data.network?data.network.node_count_total:0,
                  innerNetwork:data.network?data.network.node_count_inner:0,
                  newInnerNetwork: data.network?data.network.node_new_inner:0,
                  outerNetwork: data.network?data.network.node_count_outer:0,
                  newOuterNetwork: data.network?data.network.node_new_outer:0,
              }
          data.talent.map(value=>{
            const emailKey = value.email.replace(/\./g, '||')
            talentTeam[emailKey]=value.talent_before
          })
          commit('setTalentTeam',talentTeam)
          commit('setuserDetail',userDetail)
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  async getReportMonthly({ commit, dispatch, rootState, state }: any, value: any){
    commit("setloadingStatus",true)
    commit("setLoadingProgress",state.loadingProgress+15)

  var _directReports= {
      engagedFocus: 0,
      engagedFocusType: "highlyEngaged",
      engagedValue: {
        // superEngaged: 0,
        // oldSuperEngaged: 0,
        highlyEngaged: 0,
        oldHighlyEngaged: 0,
        moderatelyEngaged: 0,
        oldModeratelyEngaged: 0,
        somewhatEngaged: 0,
        oldSomewhatEngaged: 0,
        notEngaged: 0,
        oldNotEngaged: 0,
        inActive:0,
        oldInActive:0
      },
      engagedData: [],
    }
  
  // commit("setdirectReports",_directReports)
    let performingData:Array<any>=[]
    var PersonalGrowth:any={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    var Recognition:any={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    var Rel_Colleagues:any={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    var Satisfaction:any={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    var Ambassadorship:any={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    var Feedback:any={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    var Wellness:any={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    var Company_Alignment:any={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    var Rel_Manager:any={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
    let month = parseInt(value.num_month);
    let pastMonth = month - 1;
    let year = parseInt(format(value.year, "YYYY"));
    let dateOfPastMont = endOfMonth(new Date(year, pastMonth, 3));
    var lastDayOfMonth=parseInt(format(dateOfPastMont, "D"));
    var status_feeling={good: 0,okay: 0,critical: 0}
    const start_date = value.year + "-" + value.num_month 
    const lastDate=value.year + "-" + value.num_month+"-"+"31" 
    let feeling: Array<any>=[];
    let end_date  = format(subMonths(start_date, 1), 'YYYY-MM')
    let OldtalentTeam=state.talentTeam
    var _engagement={}
    let engagedData : Array<any> = [];
    var data_Contribution={}
    let engagement={
      challenges: {
        dailyCheck: "",
        peerFeedback: "",
        feedback: "",
        happilyVillage: "",
        superFeedback: "",
        rewards: "",
        recognition: "",
        favoritedSparks: "",
        superRecognition: "",
        NetworkBuilding: "",
      },
    }
    let directReports: Array<any>=[
      {name: "Underutilized",value: 0},
      {name: "Activated",value: 0},
      {name: "High Performer",value: 0},
      {name: "Superstar",value: 0},
      {name: "Supported",value: 0},
      {name: "High Contributor",value: 0},
      {name: "Core Player",value: 0},
      {name: "Solid Performer",value: 0},
      {name: "Up-and-coming", value: 0},
      {name: "Rising Star",value: 0},
      {name: "Developing",value: 0},
      {name: "High Potential",value: 0},
      {name: "Marginalized",value: 0},
      {name: "Contributor",value: 0},
      {name: "Crowd Favorite",value: 0},
      {name: "Hidden Talent",value: 0},
    ]
    const allUserKey = state.team
    let growingTeam: Array<any> = [];
    let holiday: Array<any> = [];
    let youFeeling: Array<any>=[];
    let team: { [key: string]: any } = {};
    let _team: Array<any> = [];
    let userCardData: any = {};
    let talentTeam: { [key: string]: any } = {};
    const teams = await getTeamByCompany(value.company)
    for(const i in teams){
       _team.push({...teams[i],key:i})
    }
        team= _.groupBy(_team, function (b) { return b.key })
      firebase.firestore().collection('/holliday').where('companyid','==',value.company).where('date','>=',`${start_date}-01`).where('date','<=',lastDate).get().then((querySnapshot)=>{
        querySnapshot.forEach((doc) => {
            const data=doc.data()
            holiday.push(data)        
        })
    })

    firebase.firestore().collection('report_monthly').where('company', '==', value.company).where("monthyear", "in", [start_date, end_date]).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          //const emailKey = data.email.replace(/\./g, '||')
          if(!_engagement[data.email+"-"+data.monthyear]){
            _engagement[data.email+"-"+data.monthyear]={}
          }
          _engagement[data.email+"-"+data.monthyear]=data
        })
        commit("setLoadingProgress",state.loadingProgress+15)

        for (const user in allUserKey) {
          
          let engagementKey: Array<any> = []
          let engagedType: string = ''
          let engagedSort=0

          var result:Array<any>=[]
          if(_engagement[allUserKey[user].email+"-"+start_date]){
          for (const excel in _engagement[allUserKey[user].email+"-"+start_date].excels) {
            let data={name:excel,value:_engagement[allUserKey[user].email+"-"+start_date].excels[excel]}
            result.push(data)
          }
        }

          if(talentTeam[allUserKey[user].talent]!=undefined)
          {
              talentTeam[allUserKey[user].talent]++
          }else {
              talentTeam[allUserKey[user].talent]=1
          }

          if(_engagement[allUserKey[user].email+"-"+start_date]){
          //======current=======
        //   if (_engagement[allUserKey[user].email+"-"+start_date].daily_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+start_date].feedback_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+start_date].super_feedback_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+start_date].recognition_color=== 'green' &&
        //   _engagement[allUserKey[user].email+"-"+start_date].super_recognition_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+start_date].happily_village_color === 'green' &&
        //   _engagement[allUserKey[user].email+"-"+start_date].favorite_spark_color === 'green' ) {
        //   engagedType = "superEngaged"
        //   engagedSort=1
          
        //   state.directReports.engagedValue.superEngaged++

        // }
        if(!_engagement[allUserKey[user].email+"-"+start_date].daily_answer){
          engagedType = "inActive"
          engagedSort=6
          _directReports.engagedValue.inActive++
        }
         else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color === 'green' &&
          _engagement[allUserKey[user].email+"-"+start_date].feedback_color === 'green' &&
          _engagement[allUserKey[user].email+"-"+start_date].super_feedback_color !== 'red' &&
          _engagement[allUserKey[user].email+"-"+start_date].recognition_color === 'green' &&
          _engagement[allUserKey[user].email+"-"+start_date].super_recognition_color !== 'red' &&
          _engagement[allUserKey[user].email+"-"+start_date].happily_village_color !== 'red' &&
          _engagement[allUserKey[user].email+"-"+start_date].favorite_spark_color !== 'red' ) {
          engagedType = "highlyEngaged"
          engagedSort=2
          
          _directReports.engagedValue.highlyEngaged++

        } else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color === 'green' &&
          _engagement[allUserKey[user].email+"-"+start_date].feedback_color !== 'red' &&
          _engagement[allUserKey[user].email+"-"+start_date].recognition_color !== 'red') {
          engagedType = "moderatelyEngaged"
          engagedSort=3
          _directReports.engagedValue.moderatelyEngaged++

        } else if (_engagement[allUserKey[user].email+"-"+start_date].daily_color !== 'red') {
          engagedType = "somewhatEngaged"
          engagedSort=4
         
          _directReports.engagedValue.somewhatEngaged++

        } else {
          engagedType = "underEngaged"
          engagedSort=5
          
          _directReports.engagedValue.notEngaged++

        }
      }
    
        // console.log("allUserKey[user].email",allUserKey[user].email)
        // console.log("daily_color", _engagement[allUserKey[user].email+"-"+start_date].daily_color)
        // console.log("feedback_color", _engagement[allUserKey[user].email+"-"+start_date].feedback_color)
        // console.log("super_feedback_color", _engagement[allUserKey[user].email+"-"+start_date].super_feedback_color)
        // console.log("recognition_color", _engagement[allUserKey[user].email+"-"+start_date].recognition_color)
        // console.log("super_recognition_color", _engagement[allUserKey[user].email+"-"+start_date].super_recognition_color)
        // console.log("peerfeedback_color", _engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color)
        // console.log("happily_village_color", _engagement[allUserKey[user].email+"-"+start_date].happily_village_color)
        // console.log("favorite_spark_color", _engagement[allUserKey[user].email+"-"+start_date].favorite_spark_color)
        // console.log("networkbulding_color", _engagement[allUserKey[user].email+"-"+start_date].networkbulding_color)
        // console.log("engagedType",engagedType)
        if(_engagement[allUserKey[user].email+"-"+end_date]){
        //======old=======
      //   if (_engagement[allUserKey[user].email+"-"+end_date].daily_color === 'green' &&
      //   _engagement[allUserKey[user].email+"-"+end_date].feedback_color === 'green' &&
      //   _engagement[allUserKey[user].email+"-"+end_date].super_feedback_color === 'green' &&
      //   _engagement[allUserKey[user].email+"-"+end_date].recognition_color=== 'green' &&
      //   _engagement[allUserKey[user].email+"-"+end_date].super_recognition_color === 'green' &&
      //   _engagement[allUserKey[user].email+"-"+end_date].peerfeedback_color === 'green' &&
      //   _engagement[allUserKey[user].email+"-"+end_date].happily_village_color === 'green' &&
      //   _engagement[allUserKey[user].email+"-"+end_date].favorite_spark_color === 'green' ) {
         
      //   state.directReports.engagedValue.oldSuperEngaged++
          

      // } 
      if(!_engagement[allUserKey[user].email+"-"+end_date].daily_answer){
       
        _directReports.engagedValue.oldInActive++
      }
      else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color === 'green' &&
        _engagement[allUserKey[user].email+"-"+end_date].feedback_color === 'green' &&
        _engagement[allUserKey[user].email+"-"+end_date].super_feedback_color !== 'red' &&
        _engagement[allUserKey[user].email+"-"+end_date].recognition_color === 'green' &&
        _engagement[allUserKey[user].email+"-"+end_date].super_recognition_color !== 'red' &&
        _engagement[allUserKey[user].email+"-"+end_date].happily_village_color !== 'red' &&
        _engagement[allUserKey[user].email+"-"+end_date].favorite_spark_color !== 'red' ) {
        
          _directReports.engagedValue.oldHighlyEngaged++
          

      } else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color === 'green' &&
        _engagement[allUserKey[user].email+"-"+end_date].feedback_color !== 'red' &&
        _engagement[allUserKey[user].email+"-"+end_date].recognition_color !== 'red' ) {
          
          _directReports.engagedValue.oldModeratelyEngaged++
          

      } else if (_engagement[allUserKey[user].email+"-"+end_date].daily_color !== 'red') {
      
        _directReports.engagedValue.oldSomewhatEngaged++
        
      } else {
       
        _directReports.engagedValue.oldNotEngaged++
        

      }
    }
    
    var networkbulding_color=""
    if((state.userDetail.newInnerNetwork+state.userDetail.newOuterNetwork)>0){
      networkbulding_color="green"
    }
    else{
      networkbulding_color="red"
    }
          if(allUserKey[user].email==value.email){
            var redeem_rewards_color=""
            if(_engagement[allUserKey[user].email+"-"+start_date] && _engagement[allUserKey[user].email+"-"+start_date].redeem_rewards_count>=1)
            {
              redeem_rewards_color="green"
            }else {
              redeem_rewards_color="red"
            }
            if(_engagement[allUserKey[user].email+"-"+start_date]){
            engagement.challenges.dailyCheck=_engagement[allUserKey[user].email+"-"+start_date].daily_color
            engagement.challenges.peerFeedback=_engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color
            engagement.challenges.feedback=_engagement[allUserKey[user].email+"-"+start_date].feedback_color
            engagement.challenges.happilyVillage=_engagement[allUserKey[user].email+"-"+start_date].happily_village_color
            engagement.challenges.superFeedback=_engagement[allUserKey[user].email+"-"+start_date].super_feedback_color
            engagement.challenges.rewards=redeem_rewards_color//_engagement[allUserKey[user].email+"-"+start_date].redeem_rewards_color
            engagement.challenges.recognition=_engagement[allUserKey[user].email+"-"+start_date].recognition_color
            engagement.challenges.favoritedSparks=_engagement[allUserKey[user].email+"-"+start_date].favorite_spark_color
            engagement.challenges.superRecognition=_engagement[allUserKey[user].email+"-"+start_date].super_recognition_color
            engagement.challenges.NetworkBuilding=networkbulding_color//_engagement[allUserKey[user].email+"-"+start_date].networkbulding_color
            let sortNot_good = _.sortBy(_engagement[allUserKey[user].email+"-"+start_date].report_card_notgood, [function (o: any) { return o.priority; }])
            let good=_engagement[allUserKey[user].email+"-"+start_date].report_card_good
            if(sortNot_good.length==0){
              engagementKey.push(good + " viewpoints that are positive & healthy")
            }else if(sortNot_good.length==1){
              engagementKey.push(sortNot_good[0].text, `${good} viewpoints that are positive & healthy`)
            }else{
              engagementKey.push(sortNot_good[0].text, sortNot_good[1].text, `${good} viewpoints that are positive & healthy`)
            }
            let setData = {
              name: allUserKey[user].firstname + " " + allUserKey[user].lastname,
              firstname: allUserKey[user].firstname,
              lastname: allUserKey[user].lastname,
              image: allUserKey[user].profilepic,
              teamName: team[allUserKey[user].team]?team[allUserKey[user].team][0].name:"",
              engagedType: engagedType,
              engagementKey: engagementKey,
              sort:engagedSort
            }
            
            engagedData.push(setData)


            //====setContributions====//
            data_Contribution={
              dailyAttendance:_engagement[allUserKey[user].email+"-"+start_date].daily,
              dailyAttendanceStatus:_engagement[allUserKey[user].email+"-"+start_date].daily_color,
              feedbackShared:_engagement[allUserKey[user].email+"-"+start_date].feedback,
              feedbackSharedStatus: _engagement[allUserKey[user].email+"-"+start_date].feedback_color,
              managerReplyRate:_engagement[allUserKey[user].email+"-"+start_date].replyrate?_engagement[allUserKey[user].email+"-"+start_date].replyrate:'',
              managerReplyRateStatus:_engagement[allUserKey[user].email+"-"+start_date].replyrate_color?_engagement[allUserKey[user].email+"-"+start_date].replyrate_color:'',
              insightsOpened:_engagement[value.email+"-"+start_date].insight?((_engagement[value.email+"-"+start_date].insight*100)>100?100:_engagement[value.email+"-"+start_date].insight*100):"",
              insightsOpenedStatus:_engagement[allUserKey[user].email+"-"+start_date].insight_color?_engagement[allUserKey[user].email+"-"+start_date].insight_color:"",
              recognitionGiven:_engagement[allUserKey[user].email+"-"+start_date].recognition,
              recognitionGivenStatus:_engagement[allUserKey[user].email+"-"+start_date].recognition_color,
              peerFeedback: _engagement[allUserKey[user].email+"-"+start_date].peerfeedback,
              peerFeedbackStatus: _engagement[allUserKey[user].email+"-"+start_date].peerfeedback_color,
              
          }
          
          ///===you feeling====
          for(let j=0;j<lastDayOfMonth;j++){
            const day=(j+1)<10?"0"+(j+1):(j+1)
            const date=value.year+"-"+value.num_month+"-"+day
            let weekend = format(date, "dd");
            
            if(weekend!=="Su"&&weekend!=="Sa"){
            var _holiday = _.find(holiday, function(value){
                return value != null && value.date == date;
              });
                if(j==0){
                    let dayLabel = format(date, "d");
                    
                    for(let i=1;i<parseInt(dayLabel);i++){
                        youFeeling.push("#DBDBDB")
                        
                    }
                    
                }
              if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer&&!_holiday){

              
                if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer[date]&&!_holiday){
                  if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer[date]==="green"){
                        youFeeling.push("#27BC6C")
                        if(!value.boss){
                          status_feeling.good++
                        }
                  }else if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer[date]==="yellow"){
                        youFeeling.push("#FFBA0D")
                        if(!value.boss){
                          status_feeling.okay++
                        }
                  }else if(_engagement[allUserKey[user].email+"-"+start_date].daily_answer[date]==="red"){
                        youFeeling.push("#F22F3C")
                        if(!value.boss){
                          status_feeling.critical++
                        }
                    
                  }else{
                    youFeeling.push("#7B7B7B")
                  }
                }else{
                    if(_holiday){
                        youFeeling.push("#DBDBDB")
                        
                    }else{
                        youFeeling.push("#7B7B7B")
                        
                    }
                }
              }else{
                if(_holiday){
                  youFeeling.push("#DBDBDB")
                  
              }else{
             
                  youFeeling.push("#7B7B7B")
                  
              }

              }
            }
          
            if(j==lastDayOfMonth-1)
            {
                
                if(youFeeling.length<25){
                    for(let i=youFeeling.length;i<25;i++)
                    {
                      
                        youFeeling.push("#DBDBDB")
                      
                        
                        
                    }
                    
                }

            }
            
          }
            
          if(!value.boss){
            
            commit('setFeeling', status_feeling)
          }
 
          if(value.boss){
            if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager){
              ///===team feeling====
              for(let j=0;j<lastDayOfMonth;j++){
                const day=(j+1)<10?"0"+(j+1):(j+1)
                const date=value.year+"-"+value.num_month+"-"+day
                let weekend = format(date, "dd");
               
                if(weekend!=="Su"&&weekend!=="Sa"){
                var _holiday = _.find(holiday, function(value){
                    return value != null && value.date == date;
                  });
                    if(j==0){
                        let dayLabel = format(date, "d");
                        
                        for(let i=1;i<parseInt(dayLabel);i++){
                          feeling.push("#DBDBDB")
                            
                        }
                        
                    }
                    if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]&&!_holiday){
                      if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="green"){
                        feeling.push("#27BC6C")
                            status_feeling.good++
                      }else if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="yellow"){
                        feeling.push("#FFBA0D")
                            status_feeling.okay++
                      }else if(_engagement[allUserKey[user].email+"-"+start_date].insight_teams_manager[date]==="red"){
                        feeling.push("#F22F3C")
                        status_feeling.critical++
                      }else{
                        feeling.push("#7B7B7B")
                      }
                    }else{
                        if(_holiday){
                          feeling.push("#DBDBDB")
                            
                        }else{
                          feeling.push("#7B7B7B")
                            
                        }
                    }
                }
                if(j==lastDayOfMonth-1)
                {
                    
                    if(feeling.length<25){
                        for(let i=feeling.length;i<25;i++)
                        {
                          feeling.push("#DBDBDB")
                            
                        }
                        
                    }
    
                }
                
            }
          }else{
            for(let i=feeling.length;i<25;i++)
            {

              feeling.push("#7B7B7B")
            }

          }

                 commit('setFeeling', status_feeling)
                commit('setTeamFeeling', feeling)
                
    
          }
        }

          if(!value.boss){

            PersonalGrowth={img: "Personal-Growth",text: "Personal Growth",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Recognition={img: "Recognition",text: "Recognition",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Rel_Colleagues={ img: "Rel.Colleagues",text: "Rel. Colleagues",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Satisfaction={ img: "Satisfaction",text: "Satisfaction",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Ambassadorship={ img: "Ambassadorship",text: "Ambassadorship",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Feedback={ img: "Feedback",text: "Feedback",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Wellness={ img: "Wellness",text: "Wellness",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Company_Alignment={ img: "Company-Alignment",text: "Company Alignment",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}
            Rel_Manager={ img: "Rel.Manager",text: "Rel. Manager",value:0,total:0,status: "",calulate:0,previous_value:0,previous_total:0,previous_calulate:0}

          }
          if(_engagement[allUserKey[user].email+"-"+start_date]){
            if(_engagement[allUserKey[user].email+"-"+start_date].dimensions){
            PersonalGrowth.value=PersonalGrowth.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth.value:0)
            Recognition.value=Recognition.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition.value:0)
            Rel_Colleagues.value=Rel_Colleagues.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues.value:0)
            Satisfaction.value=Satisfaction.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction.value:0)
            Ambassadorship.value=Ambassadorship.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship.value:0)
            Feedback.value=Feedback.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback.value:0)
            Rel_Manager.value=Rel_Manager.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager.value:0)
            Wellness.value=Wellness.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness.value:0)
            Company_Alignment.value=Company_Alignment.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment.value:0)


            PersonalGrowth.total=PersonalGrowth.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth.total:0)
            Recognition.total=Recognition.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition.total:0)
            Rel_Colleagues.total=Rel_Colleagues.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues.total:0)
            Satisfaction.total=Satisfaction.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction.total:0)
            Ambassadorship.total=Ambassadorship.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship.total:0)
            Feedback.total=Feedback.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback.total:0)
            Rel_Manager.total=Rel_Manager.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager.total:0)
            Wellness.total=Wellness.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness.total:0)
            Company_Alignment.total=Company_Alignment.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment.total:0)
            }
          }
 
          if(_engagement[allUserKey[user].email+"-"+end_date]){
            if(_engagement[allUserKey[user].email+"-"+end_date].dimensions){
            // //====old=====
            PersonalGrowth.previous_value=PersonalGrowth.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth.value:0)
            Recognition.previous_value=Recognition.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition.value:0)
            Rel_Colleagues.previous_value=Rel_Colleagues.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues.value:0)
            Satisfaction.previous_value=Satisfaction.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction.value:0)
            Ambassadorship.previous_value=Ambassadorship.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship.value:0)
            Feedback.previous_value=Feedback.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback.value:0)
            Rel_Manager.previous_value=Rel_Manager.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager.value:0)
            Wellness.previous_value=Wellness.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness.value:0)
            Company_Alignment.previous_value=Company_Alignment.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment.value:0)


            PersonalGrowth.previous_total=PersonalGrowth.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth.total:0)
            Recognition.previous_total=Recognition.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition.total:0)
            Rel_Colleagues.previous_total=Rel_Colleagues.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues.total:0)
            Satisfaction.previous_total=Satisfaction.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction.total:0)
            Ambassadorship.previous_total=Ambassadorship.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship.total:0)
            Feedback.previous_total=Feedback.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback.total:0)
            Rel_Manager.previous_total=Rel_Manager.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager.total:0)
            Wellness.previous_total=Wellness.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness.total:0)
            Company_Alignment.previous_total=Company_Alignment.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment.total:0)
            }
          }
          if(!value.boss){
            PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
            Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
            Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
            Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
            Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
            Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
            Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
            Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
            Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));
  
            PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
            PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
            performingData.push(PersonalGrowth)
            Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
            Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
            performingData.push(Recognition)
            Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
            Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
            performingData.push(Rel_Colleagues)
            Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
            Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
            performingData.push(Satisfaction)
            Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
            Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
            performingData.push(Ambassadorship)
            Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
            Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
            performingData.push(Feedback)
            Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
            Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
            performingData.push(Rel_Manager)
            Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
            Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
            performingData.push(Wellness)
            Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
            Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
            performingData.push(Company_Alignment)
              let _performingData =_.orderBy(performingData, ['calulate'], ['desc'])
              commit('setPerformingData', _performingData)
          
          }
          
          userCardData={
            name: (allUserKey[user].firstname+" "+allUserKey[user].lastname.slice(0, 1)),
            firstname: allUserKey[user].firstname,
            lastname: allUserKey[user].lastname,
            image:allUserKey[user].profilepic,
            talentChanged:OldtalentTeam[user]?(allUserKey[user].talent===OldtalentTeam[user]?true:false):false, 
            email:allUserKey[user].email,
            starPerformer:allUserKey[user].star,
            talent:allUserKey[user].talent=="Marginalized"?"Starter":(allUserKey[user].talent=="Hidden Talent"?"Hidden Gem":allUserKey[user].talent),
            oldTalent:OldtalentTeam[user]?OldtalentTeam[user]=="Marginalized"?"Starter":(OldtalentTeam[user]=="Hidden Talent"?"Hidden Gem":OldtalentTeam[user]):"",
            excelsAt:result,
            outstanding:(_engagement[allUserKey[user].email+"-"+start_date] && _engagement[allUserKey[user].email+"-"+start_date].truly) ? _engagement[allUserKey[user].email+"-"+start_date].truly : 0
        }
        commit('setuserCardData', userCardData)
        commit('setYouFeeling', youFeeling)
        commit('setContributions', data_Contribution)
        commit("setEngagement",{...engagement,engagementKey:engagementKey,engagementType:engagedType})

          }else{
            if(_engagement[allUserKey[user].email+"-"+start_date]){
            if(_engagement[allUserKey[user].email+"-"+start_date].dimensions){
            
            PersonalGrowth.value=PersonalGrowth.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth.value:0)
            Recognition.value=Recognition.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition.value:0)
            Rel_Colleagues.value=Rel_Colleagues.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues.value:0)
            Satisfaction.value=Satisfaction.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction.value:0)
            Ambassadorship.value=Ambassadorship.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship.value:0)
            Feedback.value=Feedback.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback.value:0)
            Rel_Manager.value=Rel_Manager.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager.value:0)
            Wellness.value=Wellness.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness.value:0)
            Company_Alignment.value=Company_Alignment.value+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment.value:0)


            PersonalGrowth.total=PersonalGrowth.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+start_date].dimensions.PersonalGrowth.total:0)
            Recognition.total=Recognition.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Recognition.total:0)
            Rel_Colleagues.total=Rel_Colleagues.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Colleagues.total:0)
            Satisfaction.total=Satisfaction.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Satisfaction.total:0)
            Ambassadorship.total=Ambassadorship.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Ambassadorship.total:0)
            Feedback.total=Feedback.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Feedback.total:0)
            Rel_Manager.total=Rel_Manager.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Rel_Manager.total:0)
            Wellness.total=Wellness.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Wellness.total:0)
            Company_Alignment.total=Company_Alignment.total+(_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+start_date].dimensions.Company_Alignment.total:0)
            }
          }
          if(_engagement[allUserKey[user].email+"-"+end_date]){
            if(_engagement[allUserKey[user].email+"-"+end_date].dimensions){
            // //====old=====
            PersonalGrowth.previous_value=PersonalGrowth.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth.value:0)
            Recognition.previous_value=Recognition.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition.value:0)
            Rel_Colleagues.previous_value=Rel_Colleagues.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues.value:0)
            Satisfaction.previous_value=Satisfaction.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction.value:0)
            Ambassadorship.previous_value=Ambassadorship.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship.value:0)
            Feedback.previous_value=Feedback.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback.value:0)
            Rel_Manager.previous_value=Rel_Manager.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager.value:0)
            Wellness.previous_value=Wellness.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness.value:0)
            Company_Alignment.previous_value=Company_Alignment.previous_value+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment.value:0)


            PersonalGrowth.previous_total=PersonalGrowth.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth?_engagement[allUserKey[user].email+"-"+end_date].dimensions.PersonalGrowth.total:0)
            Recognition.previous_total=Recognition.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Recognition.total:0)
            Rel_Colleagues.previous_total=Rel_Colleagues.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Colleagues.total:0)
            Satisfaction.previous_total=Satisfaction.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Satisfaction.total:0)
            Ambassadorship.previous_total=Ambassadorship.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Ambassadorship.total:0)
            Feedback.previous_total=Feedback.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Feedback.total:0)
            Rel_Manager.previous_total=Rel_Manager.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Rel_Manager.total:0)
            Wellness.previous_total=Wellness.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Wellness.total:0)
            Company_Alignment.previous_total=Company_Alignment.previous_total+(_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment?_engagement[allUserKey[user].email+"-"+end_date].dimensions.Company_Alignment.total:0)
            }
            }

      if(_engagement[allUserKey[user].email+"-"+start_date]){
          let sortNot_good = _.sortBy(_engagement[allUserKey[user].email+"-"+start_date].report_card_notgood, [function (o: any) { return o.priority; }])
          let good=_engagement[allUserKey[user].email+"-"+start_date].report_card_good
          if(sortNot_good.length==0){
            engagementKey.push(good + " viewpoints that are positive & healthy")
          }else if(sortNot_good.length==1){
            engagementKey.push(sortNot_good[0].text, `${good} viewpoints that are positive & healthy`)
          }else{
            engagementKey.push(sortNot_good[0].text, sortNot_good[1].text, `${good} viewpoints that are positive & healthy`)
          }
        
          let setData = {
            name: allUserKey[user].firstname + " " + allUserKey[user].lastname,
            firstname: allUserKey[user].firstname,
            lastname: allUserKey[user].lastname,
            image: allUserKey[user].profilepic,
            teamName: team[allUserKey[user].team]?team[allUserKey[user].team][0].name:"",
            engagedType: engagedType,
            engagementKey: engagementKey,
            sort:engagedSort
          }
          
          engagedData.push(setData)

          growingTeam.push({
            name: (allUserKey[user].firstname+" "+allUserKey[user].lastname.slice(0, 1)),
            firstname: allUserKey[user].firstname,
            lastname: allUserKey[user].lastname,
            image:allUserKey[user].profilepic,
            talentChanged:OldtalentTeam[user]?(allUserKey[user].talent===OldtalentTeam[user]?true:false):false, 
            email:allUserKey[user].email,
            starPerformer:allUserKey[user].star,
            talent:allUserKey[user].talent=="Marginalized"?"Starter":(allUserKey[user].talent=="Hidden Talent"?"Hidden Gem":allUserKey[user].talent),
            oldTalent:OldtalentTeam[user]==allUserKey[user].talent?(""):(OldtalentTeam[user]?OldtalentTeam[user]=="Marginalized"?"Starter":(OldtalentTeam[user]=="Hidden Talent"?"Hidden Gem":OldtalentTeam[user]):""),
            excelsAt:result,
            excelsCount:result.length,
            outstanding:_engagement[allUserKey[user].email+"-"+start_date].truly?_engagement[allUserKey[user].email+"-"+start_date].truly:0
        })
      }



          }
        }
        if(value.boss){
      
          PersonalGrowth.calulate=(isNaN(Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total)))) ?0:Math.round((PersonalGrowth.value)*100/(PersonalGrowth.total) );
          Recognition.calulate=(isNaN(Math.round((Recognition.value)*100/(Recognition.total)))) ?0:Math.round((Recognition.value)*100/(Recognition.total) );
          Rel_Colleagues.calulate=(isNaN(Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total)))) ?0:Math.round((Rel_Colleagues.value)*100/(Rel_Colleagues.total) );
          Satisfaction.calulate=(isNaN(Math.round((Satisfaction.value)*100/(Satisfaction.total)))) ?0:Math.round((Satisfaction.value)*100/(Satisfaction.total) );
          Ambassadorship.calulate=(isNaN(Math.round((Ambassadorship.value)*100/(Ambassadorship.total)))) ?0:Math.round((Ambassadorship.value)*100/(Ambassadorship.total) );
          Feedback.calulate=(isNaN(Math.round((Feedback.value)*100/(Feedback.total)))) ?0:Math.round((Feedback.value)*100/(Feedback.total));
          Rel_Manager.calulate=(isNaN(Math.round((Rel_Manager.value)*100/(Rel_Manager.total)))) ?0:Math.round((Rel_Manager.value)*100/(Rel_Manager.total));
          Wellness.calulate=(isNaN(Math.round((Wellness.value)*100/(Wellness.total)))) ?0:Math.round((Wellness.value)*100/(Wellness.total));
          Company_Alignment.calulate=(isNaN(Math.round((Company_Alignment.value)*100/(Company_Alignment.total)))) ?0:Math.round((Company_Alignment.value)*100/(Company_Alignment.total));

          PersonalGrowth.previous_calulate=(isNaN(Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total)))) ?0:Math.round((PersonalGrowth.previous_value)*100/(PersonalGrowth.previous_total) );
          PersonalGrowth.status=PersonalGrowth.calulate>PersonalGrowth.previous_calulate?"up":(PersonalGrowth.calulate<PersonalGrowth.previous_calulate)?"down":"equal"
          performingData.push(PersonalGrowth)
          Recognition.previous_calulate=(isNaN(Math.round((Recognition.previous_value)*100/(Recognition.previous_total)))) ?0:Math.round((Recognition.previous_value)*100/(Recognition.previous_total) );
          Recognition.status=Recognition.calulate>Recognition.previous_calulate?"up":(Recognition.calulate<Recognition.previous_calulate)?"down":"equal"
          performingData.push(Recognition)
          Rel_Colleagues.previous_calulate=(isNaN(Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total)))) ?0:Math.round((Rel_Colleagues.previous_value)*100/(Rel_Colleagues.previous_total) );
          Rel_Colleagues.status=Rel_Colleagues.calulate>Rel_Colleagues.previous_calulate?"up":(Rel_Colleagues.calulate<Rel_Colleagues.previous_calulate)?"down":"equal"
          performingData.push(Rel_Colleagues)
          Satisfaction.previous_calulate=(isNaN(Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total)))) ?0:Math.round((Satisfaction.previous_value)*100/(Satisfaction.previous_total) );
          Satisfaction.status=Satisfaction.calulate>Satisfaction.previous_calulate?"up":(Satisfaction.calulate<Satisfaction.previous_calulate)?"down":"equal"
          performingData.push(Satisfaction)
          Ambassadorship.previous_calulate=(isNaN(Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total)))) ?0:Math.round((Ambassadorship.previous_value)*100/(Ambassadorship.previous_total) );
          Ambassadorship.status=Ambassadorship.calulate>Ambassadorship.previous_calulate?"up":(Ambassadorship.calulate<Ambassadorship.previous_calulate)?"down":"equal"
          performingData.push(Ambassadorship)
          Feedback.previous_calulate=(isNaN(Math.round((Feedback.previous_value)*100/(Feedback.previous_total)))) ?0:Math.round((Feedback.previous_value)*100/(Feedback.previous_total) );
          Feedback.status=Feedback.calulate>Feedback.previous_calulate?"up":(Feedback.calulate<Feedback.previous_calulate)?"down":"equal"
          performingData.push(Feedback)
          Rel_Manager.previous_calulate=(isNaN(Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total)))) ?0:Math.round((Rel_Manager.previous_value)*100/(Rel_Manager.previous_total) );
          Rel_Manager.status=Rel_Manager.calulate>Rel_Manager.previous_calulate?"up":(Rel_Manager.calulate<Rel_Manager.previous_calulate)?"down":"equal"
          performingData.push(Rel_Manager)
          Wellness.previous_calulate=(isNaN(Math.round((Wellness.previous_value)*100/(Wellness.previous_total)))) ?0:Math.round((Wellness.previous_value)*100/(Wellness.previous_total) );
          Wellness.status=Wellness.calulate>Wellness.previous_calulate?"up":(Wellness.calulate<Wellness.previous_calulate)?"down":"equal"
          performingData.push(Wellness)
          Company_Alignment.previous_calulate=(isNaN(Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total)))) ?0:Math.round((Company_Alignment.previous_value)*100/(Company_Alignment.previous_total) );
          Company_Alignment.status=Company_Alignment.calulate>Company_Alignment.previous_calulate?"up":(Company_Alignment.calulate<Company_Alignment.previous_calulate)?"down":"equal"
          performingData.push(Company_Alignment)
          
          let _performingData =_.orderBy(performingData, ['calulate'], ['desc'])
         
          commit('setPerformingData', _performingData)
          

        }
        commit("setLoadingProgress",state.loadingProgress+25)
        directReports.map(data=>{
          const emailKey = value.email.replace(/\./g, '||')
          data.value=talentTeam[data.name]?talentTeam[data.name]:0
          data.highlight=value.talent===data.name?true:false
          data.oldhighlight=OldtalentTeam[emailKey]===data.name?true:false
          data.name=data.name=="Marginalized"?"Starter":(data.name=="Hidden Talent"?"Hidden Gem":data.name)
      })

        commit("setdirectReports",_directReports)
        commit('setGrowingData', {directReports:directReports})
        commit("setDirectReportsEngagedData",  _.sortBy(engagedData, [function (o: any) { return o.sort; }]))
        commit('setPartTalentTeam',_.orderBy(growingTeam, ['excelsCount', 'name'], ['desc','asc']))
        commit("setDirectReportsLoading", false)
        commit('setloading', false)
        commit("setloadingStatus",false)
        setTimeout(() => { 
          commit("setLoadingProgress",state.loadingProgress+26)
        }, 1000)
        
      })
    
},
   
   
    

  },
  getters: {
    engagement: (state: any) => {
      return state.engagement
    },
    current_dailyCheck: (state: any) => {
      return state.current_dailyCheck
    },
    directReports: (state: any) => {
      return state.directReports
    },
    directReportsData: (state: any) => {
      return {
        engagedValue: state.directReportsEngagedValue,
        engagedData: state.directReportsEngagedData
      }
    },
    directReportsLoading: (state: any) => {
      return state.directReportsLoading
    },
    loading: (state: any) => {
      return state.loading
    },
    userDetail:(state: any) => {
        return state.userDetail
      },
      contributions: (state: any) => {
        return state.dailyContributions
      },
      youFeeling: (state: any) => {
        return state.youFeeling
      },
      teamFeeling: (state: any) => {
        return state.teamFeeling
      },
      feeling: (state: any) => {
        return state.feeling
      },
      performingData: (state: any) => {
        return state.performingData
      },
      userCardData: (state: any) => {
        return state.userCardData
      },
      loadingStatus: (state: any) => {
        return state.loadingStatus
      },
      growingData: (state: any) => {
        return state.growingData
      },
      directReportsCardData: (state: any) => {

        return state.directReportsCardData
      },
      loadingProgress: (state: any) => {

        return state.loadingProgress
      }
    }
}
